import { render, staticRenderFns } from "./swiperSlider.vue?vue&type=template&id=2cd13940&scoped=true"
import script from "./swiperSlider.vue?vue&type=script&lang=js"
export * from "./swiperSlider.vue?vue&type=script&lang=js"
import style0 from "./swiperSlider.vue?vue&type=style&index=0&id=2cd13940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd13940",
  null
  
)

export default component.exports